// extracted by mini-css-extract-plugin
export default {"H2":"h2_H2__UwLSr","IconLeft":"h2_IconLeft__QVNC2","IconRight":"h2_IconRight__LZc2i","BorderBottom":"h2_BorderBottom__rvltO"};